// Plages de dates proposees par le selecteur. 'Custom' correspond a une periode libre,
// choisie au calendrier.
export type DateRangePreset = 'Today' | 'Yesterday' | 'Last Week' | 'Last Month' | 'Last Year' | 'Custom';

export interface IDateRangeValue {
  startDate: Date;
  endDate: Date;
}

export const DATE_RANGE_PRESETS: DateRangePreset[] = ['Today', 'Yesterday', 'Last Week', 'Last Month', 'Last Year'];

// Recalcule les bornes d'une plage a partir de son nom : seuls les choix sont conserves,
// jamais les dates, pour qu' "Aujourd'hui" reste aujourd'hui apres une restauration.
export function BuildPresetRange(preset: DateRangePreset, reference: Date = new Date()): IDateRangeValue | null {
  if (preset === 'Custom') return null;

  const endDate = new Date(reference);
  const startDate = new Date(reference);

  switch (preset) {
    case 'Today':
      break;
    case 'Yesterday':
      startDate.setDate(endDate.getDate() - 1);
      endDate.setDate(endDate.getDate() - 1);
      break;
    case 'Last Week':
      startDate.setDate(endDate.getDate() - 7);
      break;
    case 'Last Month':
      startDate.setMonth(endDate.getMonth() - 1);
      break;
    case 'Last Year':
      startDate.setFullYear(endDate.getFullYear() - 1);
      break;
  }

  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(23, 59, 59, 999);

  return { startDate, endDate };
}

// Retrouve le nom de la plage correspondant a des bornes donnees, ou 'Custom' si aucune ne
// convient : c'est ce qui fait basculer le selecteur sur "Periode libre".
export function MatchPreset(startDate: Date, endDate: Date, reference: Date = new Date()): DateRangePreset {
  for (const preset of DATE_RANGE_PRESETS) {
    const range = BuildPresetRange(preset, reference);
    if (!range) continue;

    if (IsSameDay(range.startDate, startDate) && IsSameDay(range.endDate, endDate)) return preset;
  }

  return 'Custom';
}

function IsSameDay(left: Date, right: Date): boolean {
  return left.getFullYear() === right.getFullYear()
    && left.getMonth() === right.getMonth()
    && left.getDate() === right.getDate();
}
